<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/stuList' }"
          >学员管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>操作日志</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom: 50px">
        <div class="panel-box">
          <h3 class="panel-title">操作日志</h3>
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="basicInfo"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column
                prop="time"
                label="日期时间"
                align="center"
              ></el-table-column>
              <el-table-column prop="type" label="操作类型" align="center">
              </el-table-column>
              <el-table-column
                prop="detail"
                label="操作内容"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="operator"
                label="操作账号"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.page"
              :page-sizes="[20, 50, 100]"
              :page-size="queryParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
            ></el-pagination>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
export default {
  name: "",
  data() {
    return {
      pageTotal: 0,
      basicInfo: [],
      stuId: "",
      name: "",
      queryParams: {
        page: 1,
        pageSize: 20,
      },
    };
  },
  created() {

    this.initData();
  },
  watch: {},
  methods: {
    initData() {
      this.loading = true;
      if (this.$route.query.id != undefined) {
        this.stuId = `${this.$route.query.id}`;
        this.name = `${this.$route.query.name}`;
        let params = {
          appId: this.$API.APPID,
          stuId: this.stuId,
        };
        params.pageSize = this.queryParams.pageSize;
        params.page = this.queryParams.page;
        this.eduAxiosPostRequest(
          "/edu/eduAdmin/stu/search_oper_history",
          params
        ).then((res) => {
          if (res != null) {
            // debugger
            let m = JSON.parse(res);
            this.basicInfo = m.list;
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        });
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.initData();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.initData();
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            if (response.data.rc == "0") {
              if (
                address.indexOf("stu_update") != -1 ||
                address.indexOf("stu_save") != -1 ||
                address.indexOf("extra_course_add") != -1 ||
                address.indexOf("extra_course_delete") != -1
              ) {
                resolve(JSON.stringify(response.data));
              } else {
                resolve(JSON.stringify(response.data.data));
              }
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// stuHistory.vue?4b373118